import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import CloudStorage from "../../../CloudStorage/CloudStorage";
import LoadCSSforfirstTime from "../../../CloudStorage/LoadCSSforfirstTime";
import { useTranslation } from "react-i18next";
import { IS_LOGGED_IN_USER } from "../../../assests/extention/commonfunction";
import { useStateContext } from "../../../Context/StateContext";

export default function PublicHeader() {
  const path = "Assets/scss/header.module.scss";
  const [manu, setmanu] = useState(false);
  const [onhover1, setOnhover1] = useState(false);
  const [onhover2, setOnhover2] = useState(false);
  const [onhover3, setOnhover3] = useState(false);
  const [onhover7, setOnhover7] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [activeModal, setActiveModal] = useState(null);

  const { t } = useTranslation();
  const laung = localStorage.getItem("laung");
  const { setState, clearAllFields, setAllpostfiltertab } = useStateContext();

  const navigate = useNavigate();

  // Detect if device is mobile
  const isMobile = window.innerWidth <= 1200;

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const handleNavigation = (path) => {
    const isLoggedIn = localStorage.getItem("urexperttoken");
    if (isMobile) setmanu(false);
    if (path.includes("/createpost") && (!isLoggedIn || isLoggedIn?.length < 15)) {
      navigate(`/${laung ?? "en"}/loginwithemail`, {
        state: { from: path },
      });
      return;
    }

    navigate(path);
  };
  const handleMobileNavigation = (path, options = {}) => {
    if (isMobile) {
      setmanu(false); // Close the header menu
      setOpenDropdown(null); // Close any open dropdowns
      setActiveModal(null); // Close any open modals
    }
    navigate(path, options);
    setOnhover7(false)
  };

  const navigatetopostpage = (type) => {
    let sortposttype = [];

    switch (type) {
      case 1:
        sortposttype = [{ id: 1, title: "Post & Browse Projects (PBP)" }];
        break;
      case 2:
        sortposttype = [{ id: 2, title: "Win business Opportunities (WBO)" }];
        break;
      case 3:
        sortposttype = [{ id: 3, title: "Find Part time Job (PTJ)" }];
        break;
      case 4:
        sortposttype = [{ id: 3, title: "Part time Job (PTJ) you Applied" }];
        break;
      default:
        break;
    }

    setState((prevState) => ({
      ...prevState,
      sortByTime: "",
      sortlan: "",
      sortposttype: sortposttype,
      locationType: [],
      searchlocation: "",
      location: "",
      remoteChecked: false,
      onSiteChecked: false,
      keywords: [],
      specialities: [],
      industries: [],
      subcategories: [],
      experienceLevel: "",
      minHourlyRate: "",
      maxHourlyRate: "",
      proposed: type == 4 ? 1 : "",
      viewed: "",
      wishlist: "",
      allpostfiltertab: type == 4 ? "appliedpost" : "allpost",
    }));

    setOnhover2(false);
    handleMobileNavigation(`/${laung || "en"}/searchall?type=${type}`);
  };



  return (
    <>
      <div className="container-fluid header">
        <div className="row header-row">
          <div className="logo">
            <a onClick={() => { handleNavigation(`/${laung ?? "en"}/`); }}  >  <img src={`${CloudStorage.cloudurl}/Assets/Images/common/logo.svg`} /></a>
          </div>
          <div className="menu-btn">
            <button onClick={() => setmanu(true)}>
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
          <div className={manu ? 'col-md-10 header-mobile active' : 'col-md-10 header-mobile'}>
            <div className={`mobile-menu`}>
              <ul className="menu">
                <li className="close-icon">  <button onClick={() => setmanu(false)}> <i className="fa-solid fa-xmark"></i>  </button>  </li>
                <li
                  className={onhover1 ? "active" : ""}
                  onClick={() => setOnhover1(true)}
                  onMouseEnter={() => setOnhover1(true)}
                  onMouseLeave={() => setOnhover1(false)}                 >
                  <a className="nav-item" > {t("Find experts")} <img src={`${CloudStorage.cloudurl}/Assets/Images/common/nav-icon.svg`} /></a>
                  <div className="nav-drop">
                    <a onClick={() => handleNavigation(`/${laung ?? "en"}/hireexpertsmainpage`)}>{t("Find Expert / Company")}</a>
                    <button onClick={() => handleNavigation(`/${laung ?? "en"}/createpost`)} className="btn"  ><img src={`${CloudStorage.cloudurl}/Assets/Images/common/plus.svg`} />{t("Create a post")} </button>
                  </div>
                </li>
                <li
                  className={onhover2 ? "active " : ""}
                  onClick={() => setOnhover2(true)}
                  onMouseEnter={() => setOnhover2(true)}
                  onMouseLeave={() => setOnhover2(false)}
                >
                  <a className="nav-item" > {t("Part-Time Jobs")} <img src={`${CloudStorage.cloudurl}/Assets/Images/common/nav-icon.svg`} /> </a>
                  {onhover2 &&
                    <div className="nav-drop ">
                      <a onClick={() => handleNavigation(`/${laung ?? "en"}/searchall?type=1`)}>Find Post & Browse Projects (PBP)</a>
                      <a onClick={() => handleNavigation(`/${laung ?? "en"}/searchall?type=2`)}>{t("Search Business Opportunities (WBO)")}</a>
                      <a onClick={() => handleNavigation(`/${laung ?? "en"}/searchall?type=3`)}>{t("Browse Part-Time Jobs (PTJ)")}</a>
                      {IS_LOGGED_IN_USER && <a onClick={() => handleNavigation(`/${laung ?? "en"}/searchall?type=4`)}>  {t("Jobs You Applied For")} </a>}
                    </div>}
                </li>
                <li
                  className={onhover3 ? "active" : ""}
                  onClick={() => setOnhover3(true)}
                  onMouseEnter={() => setOnhover3(true)}
                  onMouseLeave={() => setOnhover3(false)}
                >
                  <a className="nav-item" > {t("Find OTS")}  <img src={`${CloudStorage.cloudurl}/Assets/Images/common/nav-icon.svg`} /></a>
                  {onhover3 &&
                    <div className="nav-drop">
                      <a onClick={() => handleNavigation(`/${laung}/searchpackaged`)}>One Time Services (OTS)</a>
                      <a onClick={() => handleNavigation(`/${laung}/searchbuyproducts`)}>Buy & Sell with Market (BSM)</a>
                      <a onClick={() => handleNavigation(`/${laung}/searchrentproducts`)}>Turn Assets to Income (TAI)</a>
                      <a onClick={() => handleNavigation(`/${laung}/searchauction`)}>Buy & Sell with Auction (BSA)</a>
                      <a onClick={() => handleNavigation(`/${laung}/searchmergersacquisitions`)}  >Merger and Acquisition </a>
                    </div>}
                </li>
                <li>
                  <a onClick={() => { handleNavigation(`/${laung ?? "en"}/searchdownloadcv`); }} className="nav-item" > {t("Recruitment")} </a>
                </li>
                <li
                  className={onhover7 ? "active" : ""}
                  onClick={() => setOnhover7(true)}
                  onMouseEnter={() => setOnhover7(true)}
                  onMouseLeave={() => setOnhover7(false)}
                >
                  <a className="nav-item"> {t("All Services")} <img src={`${CloudStorage.cloudurl}/Assets/Images/common/nav-icon.svg`} />  </a>
                  {onhover7 &&
                    <div className="nav-drop">
                      <a onClick={() => navigatetopostpage(1)}>Find Post & Browse Projects (PBP)</a>
                      <a onClick={() => navigatetopostpage(2)}>Search Business Opportunities (WBO)</a>
                      <a onClick={() => navigatetopostpage(3)}>Browse Part-Time Jobs (PTJ)</a>
                      <a onClick={() => handleMobileNavigation(`/${laung}/searchpackaged`)}>One Time Services (OTS)</a>
                      <a onClick={() => handleMobileNavigation(`/${laung}/searchbuyproducts`)}>Buy & Sell with Market (BSM)</a>
                      <a onClick={() => handleMobileNavigation(`/${laung}/searchrentproducts`)}>Turn Assets to Income (TAI)</a>
                      <a onClick={() => handleMobileNavigation(`/${laung}/searchauction`)}>Buy & Sell with Auction (BSA)</a>
                      <a onClick={() => handleMobileNavigation(`/${laung}/searchmergersacquisitions`)}>Merger and Acquisition (MAS)</a>
                      <a onClick={() => handleMobileNavigation(`/${laung}/hireexpertsmainpage`)} >{t("Find Expert / Company")}</a>
                      <a onClick={() => handleMobileNavigation(`/${laung}/searchdownloadcv`)}>Full Time Job (FTJ)</a>
                    </div>}
                </li>
              </ul>

              <div className="styled">
                <button
                  onClick={() => handleNavigation(`/${laung ?? "en"}/loginwithemail`)}
                  type="submit"
                >
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/signin.svg`}
                  />
                  {t("Sign in")}
                </button>
                <button
                  onClick={() => handleNavigation(`/${laung ?? "en"}/signup`)}
                  type="submit"
                >
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/common/profile.svg`}
                  />
                  {t("Sign Up")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
}